<wlm-popup-wrapper
  [titleKey]="T_SCOPE + '.title'"
  [showCloseButton]="dialogData?.canClose"
  [actionsContainerClass]="'worpskace-form-actions-container'"
  (popupClose)="onButtonClose($event)"
>
  <ng-container popup-content>
    <div class="connect-form-container">
      <div class="connect-form-margin"></div>
      <tc-master-operator-workspace-form
        class="connect-form-content"
        (isValid)="onIsValid($event)"
        (valueChanges)="onValueChanges($event)"
      ></tc-master-operator-workspace-form>
      <div class="connect-form-margin"></div>
    </div>
  </ng-container>
  <ng-container popup-actions>
    <button
      mat-raised-button
      class="wtr-action-button-primary"
      onclick="this.blur()"
      (click)="onSubmit()"
      [disabled]="!isValid"
    >
      {{ T_SCOPE + '.buttons.connect' | translate }}
    </button>
  </ng-container>
</wlm-popup-wrapper>
